// v2-collection-ajax.js
(() => {
  const NAV_SELECTOR = "[data-v2-collection-nav]";
  const GRID_SELECTOR = "[data-v2-collection-grid]";

  function getProductsShopifySectionEl() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return null;
    return grid.closest('[id^="shopify-section-"]');
  }

  function getProductsSectionId() {
    const sectionEl = getProductsShopifySectionEl();
    if (!sectionEl) return null;
    return sectionEl.id.replace("shopify-section-", "");
  }

  function setActiveLink(navRoot, targetUrl) {
    const target = new URL(targetUrl, window.location.origin).toString();
    navRoot.querySelectorAll("a.clp-cats-auto__link").forEach((a) => {
      const isActive = a.href === target;
      a.classList.toggle("is-active", isActive);
      if (isActive) a.setAttribute("aria-current", "page");
      else a.removeAttribute("aria-current");
    });
  }

  async function swapProductsSection(targetUrl, { push = true } = {}) {
    const sectionId = getProductsSectionId();
    const currentSectionEl = getProductsShopifySectionEl();

    if (!sectionId || !currentSectionEl) {
      window.location.href = targetUrl;
      return;
    }

    currentSectionEl.classList.add("is-loading");

    try {
      const u = new URL(targetUrl, window.location.origin);
      u.searchParams.set("sections", sectionId);

      const res = await fetch(u.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!res.ok) throw new Error("Fetch failed");

      const json = await res.json();
      const html = json[sectionId];
      if (!html) throw new Error("Missing section HTML");

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const incomingShopifySection =
        temp.querySelector('[id^="shopify-section-"]') || temp.firstElementChild;

      if (!incomingShopifySection) throw new Error("Incoming section not found");

      // Replace only the section contents (not the wrapper id)
      currentSectionEl.innerHTML = incomingShopifySection.innerHTML;

      // Update URL without full reload
      if (push) window.history.pushState({ url: targetUrl }, "", targetUrl);

      // Update nav underline state
      const navRoot = document.querySelector(NAV_SELECTOR);
      if (navRoot) setActiveLink(navRoot, targetUrl);

      // Re-init hooks for themes/apps that listen to section load
      document.dispatchEvent(
        new CustomEvent("shopify:section:load", {
          detail: { sectionId },
        })
      );

      // Optional: scroll nicely to the grid
      const newGrid = document.querySelector(GRID_SELECTOR);
      if (newGrid) {
        const top = newGrid.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top, behavior: "smooth" });
      }
    } catch (e) {
      window.location.href = targetUrl;
    } finally {
      currentSectionEl.classList.remove("is-loading");
    }
  }

  function bindNav() {
    const navRoot = document.querySelector(NAV_SELECTOR);
    if (!navRoot) return;

    navRoot.addEventListener("click", (e) => {
      const a = e.target.closest("a");
      if (!a) return;

      // allow new tab / modified clicks
      if (a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const url = new URL(a.href, window.location.origin);
      if (url.origin !== window.location.origin) return;

      e.preventDefault();
      swapProductsSection(url.toString(), { push: true });
    });

    window.addEventListener("popstate", (ev) => {
      const url = (ev.state && ev.state.url) ? ev.state.url : window.location.href;
      swapProductsSection(url, { push: false });
    });
  }

  document.addEventListener("DOMContentLoaded", bindNav);
})();